import { render } from "./manager.vue?vue&type=template&id=0d5a2a2b&scoped=true"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"

import "./manager.vue?vue&type=style&index=0&id=0d5a2a2b&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5a2a2b"]])

export default __exports__